export interface IndexedDocumentLine {
  index: number;
}

export interface PlanLineSourceRef {
  parsed_index: number;
}

/**
 * Resolves the original dry-run line behind a review-plan row.
 *
 * Review rows can be fewer than extracted rows after aggregation, so the
 * visual position is not a safe lookup key. `parsed_index` points to the
 * original source row; the positional fallback only supports legacy/synthetic
 * plans whose indices were not persisted consistently.
 */
export function sourceLineForPlan<T extends IndexedDocumentLine>(
  sourceLines: readonly T[],
  planLine: PlanLineSourceRef,
  fallbackIndex: number,
): T | undefined {
  const sourceIndex = Number.isInteger(planLine.parsed_index)
    ? planLine.parsed_index
    : fallbackIndex;
  return sourceLines.find((line) => line.index === sourceIndex)
    ?? sourceLines[sourceIndex]
    ?? sourceLines[fallbackIndex];
}
